namespace SolovisGateway.Admin.Organizations {

    export const EnableConnectionOutcome = {
        Enabled: "Enabled",
        AlreadyEnabled: "AlreadyEnabled",
        UserNotFound: "UserNotFound",
        DomainAlreadyEnabledElsewhere: "DomainAlreadyEnabledElsewhere",
        BackendError: "BackendError",
        EnabledButNotConfirmed: "EnabledButNotConfirmed",
    } as const;
    export type EnableConnectionOutcome = typeof EnableConnectionOutcome[keyof typeof EnableConnectionOutcome];

    export interface OrgEnableConnectionDialogOptions extends SupportContactOptions {
        domains: Array<string>;
        testSignInEmail?: string;
        onEnable?: (testSignInEmail: string) => void;
        onCancel?: () => void;
    }

    export class OrgEnableConnectionDialog {

        private _options: OrgEnableConnectionDialogOptions;

        private _dialog: any;
        private _formContainer: JQuery;
        private _loaderContainer: JQuery;
        private _successContainer: JQuery;
        private _userNotFoundContainer: JQuery;
        private _domainConflictContainer: JQuery;
        private _domainConflictList: JQuery;
        private _genericFailureContainer: JQuery;
        private _partialContainer: JQuery;
        private _emailInput: JQuery;
        private _emailError: JQuery;

        constructor(options: OrgEnableConnectionDialogOptions) {
            this._options = options;
        }

        public show() {
            var self = this;

            var body = $("<div>").css({ "padding": "0 15px" });

            var formContainer = $("<div>");
            body.append(formContainer);
            this._formContainer = formContainer;

            formContainer.append($("<p>").text("Do you want to enable this connection?"));

            var domains = (this._options.domains || []).filter(function (domain) {
                return !!domain;
            });
            if (domains.length > 0) {
                var impactSentence = $("<p>").css({ "margin-bottom": "15px" });
                impactSentence.append($("<span>").text("All users on "));
                domains.forEach(function (domain, index) {
                    if (index > 0) {
                        impactSentence.append($("<span>").text(", "));
                    }
                    impactSentence.append($("<strong>").text(domain));
                });
                impactSentence.append($("<span>").text(
                    " will start signing in through your identity provider instead of a username and password."
                ));
                formContainer.append(impactSentence);
            }

            formContainer.append($("<p>").css({ "font-weight": "bold" }).text("Test sign-in email"));

            var emailInput = $("<input>")
                .attr({ "type": "text", "aria-label": "Test sign-in email" })
                .val(this._options.testSignInEmail || "")
                .css({
                    "width": "100%",
                    "box-sizing": "border-box",
                    "border": "1px solid #ddd",
                    "border-radius": "3px",
                    "padding": "7px 10px",
                    "font-size": "14px",
                    "margin-bottom": "8px"
                });
            formContainer.append(emailInput);
            this._emailInput = emailInput;

            var emailError = $("<p>")
                .css({ "color": "#a94442", "font-weight": "bold", "display": "none" })
                .text("Enter one or more valid email addresses, separated by commas.");
            formContainer.append(emailError);
            this._emailError = emailError;

            formContainer.append($("<p>").css({ "color": "#666" }).text(
                "Enter the email address you used to test this connection. You can enter more than one, as a comma-separated list."
            ));

            var warningBanner = $("<div>").attr("role", "note").css({
                "background-color": "#fcf8e3",
                "border": "1px solid #faebcc",
                "color": "#8a6d3b",
                "padding": "12px 15px",
                "border-radius": "4px"
            }).text(
                "Once the connection is enabled, any user on these domains who is not assigned to the SSO application in your identity provider will not be able to sign in until they are added there."
            );
            formContainer.append(warningBanner);

            var loaderContainer = $("<div>")
                .css({ "position": "relative", "height": "150px", "display": "none" });
            Solovis.UI.StockAnimations.createSpinningCircles({
                diameter: "60px",
                top: "50%",
                left: "50%",
                showShadow: true
            }).appendTo(loaderContainer);
            body.append(loaderContainer);
            this._loaderContainer = loaderContainer;

            var successContainer = $("<div>").css({ "display": "none" });
            successContainer.append($("<div>").css({
                "background-color": "#dff0d8",
                "border": "1px solid #d6e9c6",
                "color": "#3c763d",
                "padding": "12px 15px",
                "border-radius": "4px"
            }).text("The connection is enabled."));
            body.append(successContainer);
            this._successContainer = successContainer;

            // userNotFound — verification failed for the supplied tester email(s)
            var userNotFoundContainer = $("<div>").css({ "display": "none" });
            userNotFoundContainer.append($("<div>").css({
                "background-color": "#f2dede",
                "border": "1px solid #ebccd1",
                "color": "#a94442",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px"
            }).text(
                "We could not find a user with this email address for this connection. Make sure the identity provider is sending the correct attribute."
            ));

            var attributeTable = $("<table>").css({ "width": "100%", "border-collapse": "collapse", "margin-bottom": "15px" });
            var headerRow = $("<tr>");
            headerRow.append(
                $("<th>").css({ "text-align": "left", "padding": "8px", "border-bottom": "1px solid #ddd" }).text("Expected attribute"),
                $("<th>").css({ "text-align": "left", "padding": "8px", "border-bottom": "1px solid #ddd" }).text("Expected value")
            );
            attributeTable.append(headerRow);
            var attributeRow = $("<tr>");
            attributeRow.append(
                $("<td>").css({ "padding": "8px", "font-family": "monospace", "word-break": "break-all" }).text(
                    "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"
                ),
                $("<td>").css({ "padding": "8px", "font-family": "monospace" }).text("the user's exact email address")
            );
            attributeTable.append(attributeRow);
            userNotFoundContainer.append(attributeTable);

            userNotFoundContainer.append($("<p>").css({ "font-weight": "bold" }).text("Next Steps"));

            var remediationList = $("<ol>").css({ "margin-bottom": "15px" });
            remediationList.append(
                $("<li>").text("Map the nameidentifier attribute to the user's exact email address in your identity provider."),
                $("<li>").text("Run Validate Connection again."),
                $("<li>").text("Click Enable again.")
            );
            userNotFoundContainer.append(remediationList);
            userNotFoundContainer.append(this._buildSupportLine(
                "If the problem persists after correcting the attribute, "
            ));
            body.append(userNotFoundContainer);
            this._userNotFoundContainer = userNotFoundContainer;

            // domainAlreadyEnabledElsewhere — list conflicting domains
            var domainConflictContainer = $("<div>").css({ "display": "none" });
            domainConflictContainer.append($("<div>").css({
                "background-color": "#f2dede",
                "border": "1px solid #ebccd1",
                "color": "#a94442",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px"
            }).text(
                "One or more domains on this connection are already live on another connection. Disable or remove them from the other connection before enabling this one."
            ));
            var domainConflictList = $("<ul>").css({ "margin-bottom": "15px" });
            domainConflictContainer.append(domainConflictList);
            this._domainConflictList = domainConflictList;
            domainConflictContainer.append(this._buildSupportLine(
                "If you need help resolving the conflict, "
            ));
            body.append(domainConflictContainer);
            this._domainConflictContainer = domainConflictContainer;

            // backendError / unknown — generic retry
            var genericFailureContainer = $("<div>").css({ "display": "none" });
            genericFailureContainer.append($("<div>").css({
                "background-color": "#f2dede",
                "border": "1px solid #ebccd1",
                "color": "#a94442",
                "padding": "12px 15px",
                "border-radius": "4px",
                "margin-bottom": "15px"
            }).text(
                "We could not enable the connection. Please try again."
            ));
            genericFailureContainer.append(this._buildSupportLine(
                "If the problem continues, "
            ));
            body.append(genericFailureContainer);
            this._genericFailureContainer = genericFailureContainer;

            // enabledButNotConfirmed — Auth0 attached, Gateway DB not updated
            var partialContainer = $("<div>").css({ "display": "none" });
            partialContainer.append($("<div>").css({
                "background-color": "#fcf8e3",
                "border": "1px solid #faebcc",
                "color": "#8a6d3b",
                "padding": "12px 15px",
                "border-radius": "4px"
            }).text(
                "The connection was enabled with your identity provider, but Solovis could not " +
                "confirm the change. It may still show as not Enabled until this is corrected. Click " +
                "Enable again to finish."
            ));
            body.append(partialContainer);
            this._partialContainer = partialContainer;

            this._dialog = new (Solovis as any).UI.Dialog({
                container: body,
                title: "Enable connection",
                modal: true,
                autoOpen: true,
                center: true,
                destroyOnClose: true,
                actions: ["Close"],
                width: 600,
                buttons: this._buildDefaultButtons()
            });
        }

        public showSuccess(onClosed?: () => void) {
            this._hideResultPanels();
            this._successContainer.show();
            this._dialog.updateButtons([
                {
                    label: "Close",
                    click: () => {
                        this._dialog.close();
                        if (onClosed) {
                            onClosed();
                        }
                    }
                }
            ]);
        }

        /**
         * userNotFound — verification failed for the tester email(s).
         */
        public showFailure() {
            this._hideResultPanels();
            this._userNotFoundContainer.show();
            this._dialog.updateButtons(this._buildCancelButton());
        }

        /** domainAlreadyEnabledElsewhere — list the conflicting domain name(s). */
        public showDomainConflictFailure(conflictingDomains?: Array<string>) {
            this._hideResultPanels();
            this._domainConflictList.empty();

            var domains = (conflictingDomains || []).filter(function (domain) {
                return !!domain;
            });
            if (domains.length === 0) {
                this._domainConflictList.append($("<li>").text(
                    "A domain on this connection is already live elsewhere."
                ));
            } else {
                domains.forEach((domain) => {
                    this._domainConflictList.append($("<li>").append($("<strong>").text(domain)));
                });
            }

            this._domainConflictContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        /** backendError / unknown outcome. */
        public showGenericFailure() {
            this._hideResultPanels();
            this._genericFailureContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        // EnableConnectionOutcome.EnabledButNotConfirmed: Auth0 already attached the connection, but the Gateway DB
        // update failed afterward. Distinct from showGenericFailure() because retrying here
        // isn't "try the same thing again" — it's the only way to close the gap between what
        // Auth0 has already done and what the Gateway's own record still says.
        public showPartialFailure() {
            this._hideResultPanels();
            this._partialContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        public resetToForm() {
            this._hideResultPanels();
            this._formContainer.show();
            this._dialog.updateButtons(this._buildDefaultButtons());
        }

        private _hideResultPanels() {
            this._loaderContainer.hide();
            this._successContainer.hide();
            this._userNotFoundContainer.hide();
            this._domainConflictContainer.hide();
            this._genericFailureContainer.hide();
            this._partialContainer.hide();
            this._formContainer.hide();
        }

        private _buildSupportLine(prefix: string): JQuery {
            var supportLine = $("<p>");
            SsoConnectionStatusUi.appendSupportContactLine(supportLine, this._options, prefix, ".");
            return supportLine;
        }

        private _buildDefaultButtons() {
            var self = this;
            return [
                {
                    label: "Enable",
                    click: function () {
                        self._attemptEnable();
                    }
                },
                {
                    label: "Cancel",
                    click: function () {
                        self._dialog.close();
                        if (self._options.onCancel) {
                            self._options.onCancel();
                        }
                    }
                }
            ];
        }

        /** No Enable button — used only by showFailure() (userNotFound), where an inline retry
         *  can't succeed until the identity provider attribute is fixed and Validate Connection
         *  is run again outside this dialog. */
        private _buildCancelButton() {
            var self = this;
            return [
                {
                    label: "Cancel",
                    click: function () {
                        self._dialog.close();
                        if (self._options.onCancel) {
                            self._options.onCancel();
                        }
                    }
                }
            ];
        }

        private _attemptEnable() {
            var emailValue = this._emailInput.val() as string;

            if (!this._isValidEmailList(emailValue)) {
                this._hideResultPanels();
                this._formContainer.show();
                this._emailInput.css({ "border-color": "#a94442" });
                this._emailError.show();
                this._dialog.updateButtons(this._buildDefaultButtons());
                return;
            }

            this._emailInput.css({ "border-color": "#ddd" });
            this._emailError.hide();

            this._hideResultPanels();
            this._loaderContainer.show();
            this._dialog.updateButtons([]);

            if (this._options.onEnable) {
                this._options.onEnable(emailValue);
            }
        }

        private _isValidEmailList(value: string): boolean {
            var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            var entries = (value || "").split(",").map(function (entry) {
                return entry.trim();
            }).filter(function (entry) {
                return entry.length > 0;
            });

            return entries.length > 0 && entries.every(function (entry) {
                return emailPattern.test(entry);
            });
        }
    }
}
